import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider, defaultSystem } from '@chakra-ui/react';
import { BrowserRouter } from "react-router-dom";
import { TostMessageProvider } from './context/TostMessage';
import { CookiesProvider } from 'react-cookie';
import { UserProvider } from './context/UserContext';
import { MenuProvider } from './context/MenuContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <TostMessageProvider>
        <CookiesProvider defaultSetOptions={{ path: '/' }}>
          <ChakraProvider value={defaultSystem}>
            <UserProvider>
              <MenuProvider>
                <App />
              </MenuProvider>
            </UserProvider>
          </ChakraProvider>
        </CookiesProvider>
      </TostMessageProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
